export const SEAHORSE_BUILD_NO = 1715591352910;
